
<div class="inline-parent">
  <h2 :class="headingClass">{{contentElement.label_title}}
    <help-tooltip v-if="contentElement.help_text" :text="contentElement.help_text"></help-tooltip>
  </h2>
</div>

